import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getTitle } from '../../../helpers/admin/productHelper';
import { formatProductReviews } from '../../../helpers/shop/shopHelper';

import shape from '../../../assets/resources/shape.png';

//Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from "swiper";
import 'swiper/css';
import "swiper/css/navigation";

//MUI
import {
    Container, Box, IconButton, Typography, Link, Grid, Stack
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const RecentlyViewed = ({ product_id }) => {
    const navigate = useNavigate();
    const {
        rvProducts // productos vistos recientemente
    } = useSelector(state => state.shop);
    
    const [products, setProducts] = useState([]);

    useEffect(() => {
        setProducts(rvProducts.filter(e => e.prod_id !== product_id));
    }, [rvProducts]);

    // dirigirse a página de variante
    const goToProductPage = (url, barcode) => () => {
        navigate(`/tienda/producto/${url}/${barcode}`);
    };

    return (
        products.length > 0 &&
        <Container maxWidth='xxl' sx={{ mt: 5 }}>
            <Typography variant='h5' color='text.primary'
                sx={{ fontSize: '26px', mb: 5 }}
                textAlign='center'>
                Productos vistos recientemente
            </Typography>

            <Grid container spacing={2} sx={{ textAlign: 'center' }}>
                <Grid item xl={1} lg={1} md={1} sm={2} xs={2} sx={{ my: 'auto' }}>
                    <IconButton className='recentlyViewed-swiper-button-prev' size='small'>
                        <ChevronLeftIcon />
                    </IconButton>
                </Grid>
                <Grid item xl={10} lg={10} md={10} sm={8} xs={8}>
                    <Swiper
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                            },
                            610: {
                                slidesPerView: 2,
                            },
                            800: {
                                slidesPerView: 2,
                            },
                            950: {
                                slidesPerView: 3,
                            },
                            1100: {
                                slidesPerView: 3,
                            },
                            1200: {
                                slidesPerView: 4,
                            },
                        }}
                        spaceBetween={40}
                        navigation={{
                            nextEl: '.recentlyViewed-swiper-button-next',
                            prevEl: '.recentlyViewed-swiper-button-prev',
                        }}
                        loop={true}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        modules={[Navigation, Pagination]}>
                        {
                            products.map(({
                                prod_var_id, title, variant_title, url, price,
                                barcode, img, review_summary, item_promotion
                            }) => {
                                const full_title = getTitle(title, variant_title);
                                // reseñas de producto
                                const { review_prom, review_count } = formatProductReviews(review_summary);
                                const { promo, price: promo_price, text, fontSize, description: promotionDescription } = item_promotion;
                                
                                return (
                                    <SwiperSlide key={prod_var_id}
                                        style={{ textAlign: 'center' }}>
                                        <Link component="button" variant="body1"
                                            onClick={ goToProductPage(url, barcode) }>
                                            <img src={ img.id }
                                                width='100%'
                                                style={{ objectFit: 'contain' }}
                                                alt={ img.alt }
                                            />
                                        </Link>

                                        {
                                            promo !== '' &&
                                                <div className="shop_top-image" title={promotionDescription}>
                                                    <img src={shape} alt={shape} width='75'
                                                        style={{ pointerEvents: 'none' }}
                                                    />
                                                    <div className="shop_centered_image">
                                                        {
                                                            <Typography sx={{ color: '#fff', fontSize, fontWeight: 'bold' }}>
                                                                { text }
                                                            </Typography>
                                                        }
                                                    </div>
                                                </div>
                                        }

                                        <Typography variant='body1'
                                            gutterBottom
                                            sx={{ fontWeight: '600' }}>
                                            { full_title }
                                        </Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                            <div className="ratings-shop">
                                                {
                                                    review_count > 0 ?
                                                        Array.from(Array(review_prom), (e, j) => {
                                                            return <i className="fas fa-star"
                                                                style={{
                                                                    color: '#FFA41C',
                                                                    stroke: "#FFA41C",
                                                                    strokeWidth: 0.2
                                                                }}
                                                                key={j}></i>
                                                        })
                                                        :
                                                        <>
                                                            <i className="far fa-star"></i>
                                                            <i className="far fa-star"></i>
                                                            <i className="far fa-star"></i>
                                                            <i className="far fa-star"></i>
                                                            <i className="far fa-star"></i>
                                                        </>
                                                }
                                            </div>
                                        </Box>
                                        
                                        {
                                            ['DescuentoProducto', 'DescuentoMarca'].includes(promo) ?
                                                <Stack
                                                    direction="row"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    spacing={1}>
                                                    <Typography variant="h6"
                                                        sx={{ fontWeight: '600', color: '#000', textDecoration: 'line-through' }}>
                                                        ${price}
                                                    </Typography>
                                                    <Typography variant="h6"
                                                        sx={{ fontWeight: '600', color: '#F90606' }}>
                                                        ${ promo_price }
                                                    </Typography>
                                                </Stack>
                                            :
                                                <Typography variant="h6"
                                                    sx={{ fontWeight: '600', color: '#F90606' }}>
                                                    ${price}
                                                </Typography>
                                        }
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                </Grid>
                <Grid item xl={1} lg={1} md={1} sm={2} xs={2} sx={{ my: 'auto' }}>
                    <IconButton className='recentlyViewed-swiper-button-next' size='small'>
                        <ChevronRightIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Container>
    );
};

export default RecentlyViewed;
